import React from "react";
import st from "./loader.module.css";

const Loader = () => {
  return (
    <div
      style={{
        userSelect: "none",
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(108,108,108,0)",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div className={st.hourglass} />
    </div>
  );
};

export default Loader;
